var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CopyCustomFieldApi } from './apis/copy-custom-field-api.interface';
let CopyCustomFieldRepositoryImpl = class CopyCustomFieldRepositoryImpl {
    constructor(_copyCustomFieldApi) {
        this._copyCustomFieldApi = _copyCustomFieldApi;
    }
    copyCustomField(options) {
        const request = {
            user_ids: options.userIds,
            groups: options.groupIds,
            field_list: options.fields.map(this._formatField),
        };
        return this._copyCustomFieldApi.copyCustomField(request);
    }
    _formatField(field) {
        return {
            ...field,
            created_by: field.created_by.email || field.created_by.mobile_number || '',
        };
    }
};
CopyCustomFieldRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(CopyCustomFieldApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof CopyCustomFieldApi !== "undefined" && CopyCustomFieldApi) === "function" ? _a : Object])
], CopyCustomFieldRepositoryImpl);
export { CopyCustomFieldRepositoryImpl };
